// extracted by mini-css-extract-plugin
export default {"CompanyAvatar":"styles_CompanyAvatar__bDkHf"};